import { Controller } from '@hotwired/stimulus'

// Filters a list of checkbox labels based on typed text (client-side).
export default class extends Controller {
  static targets = ['input', 'option', 'list', 'clear']

  connect () {
    this.originalOrder = this.optionTargets.map((el) => el)
    this.filter()
  }

  filter () {
    const query = this.inputTarget.value.trim().toLowerCase()
    const isSearching = query.length > 0

    // ILIKE-style behavior: case-insensitive match, and matching categories
    // move to the top (we do NOT hide non-matching categories).
    if (!isSearching) {
      this.originalOrder.forEach((el) => this.listTarget.appendChild(el))
    } else {
      const byOriginalIndex = new Map(this.originalOrder.map((el, i) => [el, i]))
      const matching = []
      const nonMatching = []

      this.optionTargets.forEach((el) => {
        const text = (el.dataset.filterText || '').toLowerCase()
        const matches = text.includes(query)
        if (matches) matching.push(el)
        else nonMatching.push(el)
      })

      matching.sort((a, b) => byOriginalIndex.get(a) - byOriginalIndex.get(b))
      nonMatching.sort((a, b) => byOriginalIndex.get(a) - byOriginalIndex.get(b))

      matching.concat(nonMatching).forEach((el) => this.listTarget.appendChild(el))
    }

    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle('hidden', query.length === 0)
    }
  }

  clear (event) {
    event?.preventDefault()
    this.inputTarget.value = ''
    this.filter()
    this.inputTarget.focus({ preventScroll: true })
  }
}

